import React, { useEffect, useMemo } from 'react';
import {
  WithComponents,
  CustomMessageActions,
  DefaultStreamChatGenerics,
  MessageActionsArray,
  MessageList as DefaultMessageList,
  MessageListProps,
  useChannelActionContext,
  useChatContext, useComponentContext,
  MessageTimestamp as DefaultMessageTimestamp,
  MessageText,
} from 'stream-chat-react';
import { Channel, UserResponse } from 'stream-chat';
import type { ComponentContextValue, EventComponentProps } from 'stream-chat-react';
import { getMessageSenderName } from 'components/chat/utils';
import { ChatGenerics } from '../streamTypes';
import { useProfile } from 'api/user/profile';

import { openNewTicketForm } from '../../common/freshchat/openNewTicketForm';
import { Message } from '../Message/Message';
import { useChatContext as useProcursysChatContext } from '../ChatContext';

const msgCustomActions: CustomMessageActions = {
  'Create Procursys Support Ticket': openNewTicketForm,
};

const messageActions: MessageActionsArray = ['react'];

const CustomSystemMessage = ({ message }: EventComponentProps) => {
  const profile = useProfile();
  const { user } = message;
  const { channel } = useChatContext('MessageSystem');
  const { botMessagesHidden } = useProcursysChatContext();
  // const { tDateTimeParser } = useTranslationContext('MessageSystem');
  const { MessageTimestamp = DefaultMessageTimestamp } = useComponentContext('MessageSystem');

  if (message.type === 'system' && botMessagesHidden) {
    return null;
  }

  const userName = useMemo(() => getMessageSenderName(user as UserResponse<ChatGenerics> | undefined, channel as Channel<any>, profile),
    [channel, user, profile],
  );

  return (
    <div className="str-chat__message--system" data-testid="message-system">
      <div className="str-chat__message--system__text">
        <div className="str-chat__message--system__line" />
        <p>
          <MessageText message={message} />
        </p>
        <div className="str-chat__message--system__line" />
      </div>
      <div className="str-chat__message--system__date">
        <strong>
          {userName}
          {' | AUTO MESSAGE | '}
          <MessageTimestamp message={message} />
        </strong>
      </div>
    </div>
  );
};

export const MessageList: React.FC<MessageListProps> = (props) => {
  const { botMessagesHidden, channelJumpTarget: { msgId, setMsgId } } = useProcursysChatContext();
  const { jumpToMessage } = useChannelActionContext();

  useEffect(() => {
    if (msgId) {
      setMsgId(null);
      jumpToMessage(msgId);
    }
    // eslint-disable-next-line
  }, [jumpToMessage, msgId]);

  return (
    <WithComponents overrides={{ MessageSystem: CustomSystemMessage }}>
      <DefaultMessageList
        disableDateSeparator={botMessagesHidden}
        customMessageActions={msgCustomActions}
        messageActions={messageActions}
        Message={Message as ComponentContextValue<DefaultStreamChatGenerics>['Message']}
        {...props}
      />
    </WithComponents>
  );
};
